import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

/**
 * Service to manage custom loading states that can be used by resolvers
 * and other components to show loading indicators independently of network requests.
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false)
  public loading$: Observable<boolean> = this.loadingSubject.asObservable()

  /**
   * Set loading state to true
   */
  public showLoading(): void {
    this.loadingSubject.next(true)
  }

  /**
   * Set loading state to false
   */
  public hideLoading(): void {
    this.loadingSubject.next(false)
  }

  /**
   * Execute a function with loading state
   * @param fn Function to execute while showing loading
   * @returns Promise that resolves with the function result
   */
  public async withLoading<T>(fn: () => Promise<T> | T): Promise<T> {
    try {
      this.showLoading()
      const result = await fn()
      return result
    } finally {
      this.hideLoading()
    }
  }
} 